import { Center, Container, Image, Text } from '@chakra-ui/react';
import { ContentCard } from 'layout/ContentCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PageMetatags from '../layout/PageMetatags';

export const BreakPage: FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageMetatags title={`${t('pages:break.meta.title')} `} />
      <Container maxW="lg" py={{ base: '12', md: '16' }} px={{ base: '0', sm: '8' }}>
        <ContentCard header={t('pages:break.header')} data-test-id="break-card">
          <Text whiteSpace={'pre-wrap'} p={2}>
            {t('pages:break.description')}
          </Text>
          <Center p={2}>
            <Image src="/images/break.jpg" alt="break" w={'auto'} />
          </Center>
        </ContentCard>
      </Container>
    </>
  );
};

export default BreakPage;
